export default "__VITE_ASSET__Dsnf9CMg__"